/**
 * token 操作封装
 */

/**
 * 获取缓存的 token
 */
export function getToken() {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return sessionStorage.getItem('access_token');
  }
  return token;
}

/**
 * 缓存 token
 * @param token token
 * @param remember 是否永久存储
 */
export function setToken(token, remember) {
  removeToken();
  if (token) {
    if (remember) {
      localStorage.setItem('access_token', token);
    } else {
      sessionStorage.setItem('access_token', token);
    }
  }
}

/**
 * 移除 token
 */
export function removeToken() {
  localStorage.removeItem('access_token');
  sessionStorage.removeItem('access_token');
}


// /**
//  * 获取 token
//  */
// export function getToken() {
//   const name = 'access_token=';
//   const cookies = document.cookie.split(';');
//   for (let i = 0; i < cookies.length; i++) {
//     const cookie = cookies[i].trim();
//     if (cookie.startsWith(name)) {
//       return cookie.substring(name.length, cookie.indexOf(';'));
//     }
//   }

//   const localStorageToken = localStorage.getItem('access_token');
//   if (localStorageToken) {
//     return localStorageToken;
//   }
//   return null;
// }

// /**
//  * 缓存 token
//  * @param token token
//  * @param remember 是否记住
//  * @param expires 过期时间
//  */
// export function setToken(token, remember, expires) {
//   removeToken();

//   if (token) {
//     if (remember) {
//       localStorage.setItem('access_token', token);
//     } else {
//       let cookieStr = `access_token=${token}; path=/;`;
//       const tenHoursLater = new Date();
//       tenHoursLater.setHours(tenHoursLater.getHours() + 10);
//       cookieStr += `expires=${tenHoursLater.toUTCString()};`;

//       if (expires) {
//         const expiresDate = new Date(expires);
//         cookieStr += `expires=${expiresDate.toUTCString()};`;
//       }

//       document.cookie = cookieStr;
//     }
//   }
// }

// /**
//  * 移除token
//  */
// export function removeToken() {
//   localStorage.removeItem('access_token');
//   document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
// }